import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import DiaryService from '../../../pages/members/Services/DiaryService';
import EmployerService from '../../../pages/members/Services/EmployerService';
import { diaryUrl, employerListUrl, workActivityUrl, helpUrl, reportsUrl, addEmployerUrl, faqUrl } from '../../../pages/members/Shared/Constants/AppConstant';
import { useAuth } from '../../../providers/AuthProvider';
import SweetAlertService from '../../../services/SweetAlertService';

interface PopoverProps {
    isOpen: boolean;
    target: string;
    content: string;
    header: string;
    onClose: () => void;
}

const CustomPopover = ({
    isOpen,
    target,
    content,
    header,
    onClose,
}: PopoverProps) => {
    return (
        <div>
            <Popover
                placement="bottom"
                isOpen={isOpen}
                target={target}
                className="custom-popover"
            >
                <PopoverHeader className="custom-popover-header pe-0 py-3">
                    {header}
                    <button
                        className="btn-close pe-2 float-end me-1 my-1"
                        onClick={onClose}
                    ></button>

                </PopoverHeader>
                <PopoverBody>
                    <div>{content}</div>
                </PopoverBody>
                <div className="custom-popover-footer mt-3 mb-2">
                    <button
                        className="btn btn-default mt-2 pull-right ps-2 pe-2 me-2 my-2"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </Popover>
            <div className={isOpen ? "fade modal-backdrop show" : ""}></div>
        </div>
    );
};

export const UserNavigation = () => {
    let auth = useAuth();
    const location = useLocation();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [DiaryPopoverOpen, setDiaryPopoverOpen] = useState(false);
    const [reportPopoverOpen, setReportPopoverOpen] = useState(false);

    useEffect(() => {
        getWorkActivityCount();
        getDiaryCount();
    }, []);

    const getWorkActivityCount = () => {
        EmployerService.getWorkActivityCount().then((res) => {
            if (res) {
                setPopoverOpen(res.data == 0);
            }
        });
    }

    const getDiaryCount = () => {
        DiaryService.getDiaryCount().then((res) => {
            if (res) {
                setDiaryPopoverOpen(res.data == 0);
                setReportPopoverOpen(res.data == 0);
            }
        });
    }

    //if user clicks on close button in WorkActivity Popover default member workActivity should be added.
    const handleClosePopover = () => {
        setPopoverOpen(false);
        EmployerService.addDefaultMemberWorkActivity().then((res: any) => {
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", "Error while adding default workactivities");
            }
        })
    }

    //if user clicks on close button in Diary Popover should be closed.
    const handleClose = () => {
        setDiaryPopoverOpen(false);
        auth?.setIsDiaryPopoverIsShown();
    }

    //if user clicks on close button in Report Popover should be closed.
    const handleCloseReportPopover = () => {
        setReportPopoverOpen(false);
        auth?.setIsReportPopoverIsShown();
    }

    return (
        <div>
            {/*when user visits employer page for the first time show this pop up.*/}
            {location.pathname === employerListUrl && popoverOpen && (
                <CustomPopover
                    isOpen={popoverOpen}
                    target="workActivityPopOver"
                    header="Getting started: Step 1 of 2"
                    content="Once you have finished adding all your workplace details, update your work activities to reflect your workload."
                    onClose={handleClosePopover}
                />
            )}

            {/*when user visits WorkActivity page for the first time show this pop up.*/}
            {location.pathname === workActivityUrl && !(auth?.getIsDiaryPopoverIsShown()) && DiaryPopoverOpen && (
                <CustomPopover
                    isOpen={DiaryPopoverOpen}
                    target="dairyPopOver"
                    header="Getting started: Step 2 of 2"
                    content="When you have finished updating your work activities, you can start tracking your work in the diary."
                    onClose={handleClose}
                />
            )}

            {/*when user visits Diary page for the first time show this pop up.*/}
            {location.pathname === diaryUrl && !(auth?.getIsReportPopoverIsShown()) && reportPopoverOpen && (
                <CustomPopover
                    isOpen={reportPopoverOpen}
                    target="reportPopOver"
                    header="Reports"
                    content="After you have added several weeks of activities, you can go on to create reports that will help you to understand your work patterns."
                    onClose={handleCloseReportPopover}
                />
            )}

            <ul className="navigation-list">
                <li className={`navigation-item ${location.pathname === employerListUrl || location.pathname === addEmployerUrl ? "navigation-item--active" : ""}`}>
                    <Link to={employerListUrl} className="navigation-item__link">
                        Workplace details <svg className="icon icon--chevron"></svg>
                    </Link>
                </li>
                <li className={`navigation-item ${location.pathname === workActivityUrl ? "navigation-item--active" : ""}`}>
                    <Link to={workActivityUrl} id="workActivityPopOver" className="navigation-item__link">
                        Work activities <svg className="icon icon--chevron"></svg>
                    </Link>
                </li>
                <li className={`navigation-item ${location.pathname === diaryUrl ? "navigation-item--active" : ""}`}>
                    <Link to={diaryUrl} id="dairyPopOver" className="navigation-item__link">
                        Diary <svg className="icon icon--chevron"></svg>
                    </Link>
                </li>
                <li className={`navigation-item ${location.pathname === reportsUrl ? "navigation-item--active" : ""}`}>
                    <Link to={reportsUrl} id="reportPopOver" className="navigation-item__link">
                        Reports <svg className="icon icon--chevron"></svg>
                    </Link>
                </li>
                <li className={`navigation-item ${location.pathname === helpUrl || location.pathname === faqUrl ? "navigation-item--active" : ""}`}>
                    <Link to={helpUrl} className="navigation-item__link">
                        Help <svg className="icon icon--chevron"></svg>
                    </Link>
                </li>
            </ul>
        </div>
    )
}